<template>
	<div>
		<br />
		<div class="flex">
			<div class="w-full">
				<div class="flex justify-between mb-4">
					<div class="text-left font-bold text-lg">{{ $t('own_rental_pricing') }}</div>
					<div class="text-left italic text-md" v-if="this.lastUpdate">{{ $t('current_state_input') }} {{ this.lastUpdate }}</div>
				</div>
				<div v-if="repairShopPricings" class="flex" :class="isARentalCarSelected ? '' : 'grid grid-cols-2 gap-8'">
					<div v-for="(item, index) in repairShopPricings" :key="index">
						<RentalCarRepairShopPricingCard
							:price-item="item"
							:ref="'rentalCarPricingRepairShopCard'+index"
							:is-editable="editable"
							:is-dat-table="false"
							:class-index="index"
							@input="$emit('input')"
							:is-active-card="checkIfActiveCard(item.car_class)"
							:is-a-rental-car-selected="isARentalCarSelected"
							@importDat="importDat"
						></RentalCarRepairShopPricingCard>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import RentalCarRepairShopPricingCard from '@/components/rentalcars/cards/RentalCarRepairShopPricingCard';
import { getStringFromDate } from '@/plugins/Utils';
import Validate from "@/mixins/Validate";

export default {
	name: 'RentalCarPricingRepairShopForm',
	components: { RentalCarRepairShopPricingCard },
	mixins: [Validate, Authentication],
	props: {
		selectedRentalCarClass: {},
		repairShopPricings: {},
		editable: {},
	},
	data() {
		return {
			activeCardIndex: null,
			lastUpdate: null,
		};
	},
	computed: {
		isARentalCarSelected() {
			return this.selectedRentalCarClass !== null;
		},
	},
	watch: {
		repairShopPricings: function() {
			this.lastUpdate = getStringFromDate(new Date((this.repairShopPricings[0].updated_at ?? this.repairShopPricings[0].created_at) * 1000));
		},
	},
	methods: {
		checkIfActiveCard(carClass) {
			return this.selectedRentalCarClass === carClass;
		},
		importDat($event) {
			this.$set(this.repairShopPricings, $event, this.datPrices[$event]);
		},
	},
};
</script>

<style lang="sass" scoped>
.tr:nth-child(even)
@apply bg-white

.tr:nth-child(odd)
@apply bg-gray-200

.form-group
@apply mb-0
</style>
